export var source_release_notes = { "uid": "source_release_notes", "fields": { "title": { "defaultValue": "" } } };
